import {stage} from 'constants/url';
import useAdd from 'components/hooks/useAdd';
import {AddingOptions} from 'components/grid-dx/types';

function useAddStage() {
  const addStage = useAdd(stage);
  return (addingOptions: AddingOptions) => addStage(addingOptions);
}

export default useAddStage;
